import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Reagent splash → fade out once React has painted its first frame.
// Two RAFs guarantee the React tree is in the DOM before we start the fade.
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    // Small minimum-visible delay so the logo gets a chance to be appreciated
    // on fast networks and the fade doesn't feel like a flicker.
    setTimeout(() => {
      document.body.classList.add("app-ready");
      const splash = document.getElementById("reagent-splash");
      if (splash) {
        // Match CSS transition duration; remove the node after the fade.
        splash.addEventListener("transitionend", () => splash.remove(), { once: true });
        // Safety net: force-remove after 1.2s in case transitionend never fires.
        setTimeout(() => splash && splash.remove(), 1200);
      }
    }, 650);
  });
});
